const breakpoints: {
  breakpointsList: number[];
  desktopL: number;
  desktopM: number;
  desktopS: number;
  desktopXl: number;
  mobileM: number;
  mobileS: number;
  tablet: number;
} = {
  breakpointsList: [576, 768, 992, 1300, 1460, 1620],
  desktopL: 1460,
  desktopM: 1300,
  desktopS: 992,
  desktopXl: 1620,
  mobileM: 576,
  mobileS: 320,
  tablet: 768
};

export default breakpoints;
